import './style.scss';

import React from 'react';
import ProgressBar from 'components/ui/progressBar';
import config from 'sharedConfig';
import { LightHR } from 'scy/HR';
import { fontSizeXS, sansSerifMedium } from 'scy/text/styles.mod.scss';
import { textCenter, borderBox } from 'scy/utils.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import {
  progressBar,
  progressBarLeft,
  progressBarRight
} from './freeShippingMeter.mod.scss';

function FreeShippingMeter({ subtotal }) {
  const threshold = config.shipping.freeThreshold;
  const diff = (threshold - subtotal).toFixed(2);
  const success = diff <= 0;
  const percentage = success ? 100 : (subtotal / threshold) * 100;

  return (
    <div
      className={`${sansSerifMedium} ${fontSizeXS} ${textCenter} ${borderBox}`}
    >
      <div className={padding.sm}>
        <div className={margin.bottom_xs}>
          {success
            ? `Congrats, you've unlocked FREE shipping!`
            : `$${diff} away from FREE shipping`}
        </div>
        <div className={progressBarLeft}>$0</div>
        <ProgressBar className={progressBar} percentage={percentage} />
        <div className={progressBarRight}>${threshold}</div>
      </div>
      <LightHR marginClass={`${margin.left_sm} ${margin.right_sm}`} />
    </div>
  );
}

export default FreeShippingMeter;
